export const uk = {
    header: {
      business: "Бізнес",
      client: "Клієнт",
    },
    hero: {
      title: "Швидкі та надійні платежі для бізнесу та користувачів",
      subtitle: "Приймайте криптовалюту та фіат, миттєві транзакції, повна безпека",
      businessButton: "Підключити бізнес",
      walletButton: "Створити гаманець",
    },
    features: {
      title: "Переваги Feennex",
      items: {
        fastTransactions: {
          title: "Швидкі транзакції",
          description: "Миттєві перекази в криптовалюті та фіаті",
        },
        security: {
          title: "Безпека",
          description: "Захист за допомогою багаторівневого шифрування",
        },
        globalReach: {
          title: "Глобальне охоплення",
          description: "Працюємо з клієнтами по всьому світу",
        },
        flexibleSettings: {
          title: "Гнучкі налаштування",
          description: "Адаптація під бізнес та користувачів",
        },
        transparency: {
          title: "Прозорість",
          description: "Відсутність прихованих комісій",
        },
        instantSettlement: {
          title: "Миттєвий сетлмент",
          description: "Кошти доступні до виведення відразу після надходження платежу T+0",
        },
      },
    },
    howItWorks: {
      title: "Як працює Feennex для бізнесу?",
      steps: {
        createAccount: {
          title: "Створення акаунту",
          description: "Реєстрація та налаштування платіжного кабінету",
        },
        connectApi: {
          title: "Підключення API",
          description: "Проста інтеграція у ваш бізнес",
        },
        payments: {
          title: "Прийом та відправка платежів",
          description: "Миттєві перекази в криптовалюті та фіаті",
        },
        management: {
          title: "Управління фінансами",
          description: "Аналітика, звіти, конвертація",
        },
      },
    },
    footer: {
      tagline: "Приймайте платежі в криптовалюті та фіаті",
      contact: "Зв'язатися з нами",
      service: "Сервіс",
      apiDocs: "API Документація",
      documents: "Документи",
      privacy: "Політика конфіденційності",
      terms: "Користувацька угода",
      copyright: "Copyright © 2025 feennex.com Усі права захищені",
    },
    policies: {
      aml: {
        title: "Політика протидії відмиванню грошей",
        content: "... AML policy content in Ukrainian ..."
      },
      privacy: {
        title: "Політика конфіденційності",
        content: "... Privacy policy content in Ukrainian ..."
      },
      terms: {
        title: "Умови надання послуг",
        content: "... Terms of Service content in Ukrainian ..."
      }
    },
    aml: {
        title: "Політика протидії відмиванню грошей",
        content: `<h2>1. Вступ</h2>
                    <p>1.1. Ця Політика протидії відмиванню грошей (AML) окреслює зобов'язання Feennex щодо запобігання відмиванню грошей та фінансуванню тероризму.</p>
                    <p>1.2. Ми підтримуємо суворе дотримання міжнародних норм AML.</p>

                    <h2>2. Належна перевірка клієнтів</h2>
                    <p>2.1. Ми впроваджуємо такі заходи:</p>
                    <ul>
                        <li>Ідентифікація та верифікація клієнтів</li>
                        <li>Оцінка ризиків клієнтів та транзакцій</li>
                        <li>Постійний моніторинг транзакцій</li>
                        <li>Ведення записів усіх верифікацій</li>
                    </ul>

                    <h2>3. Оцінка ризиків</h2>
                    <p>3.1. Ми оцінюємо ризики на основі:</p>
                    <ul>
                        <li>Профілю клієнта</li>
                        <li>Шаблонів транзакцій</li>
                        <li>Географічного розташування</li>
                        <li>Ділових відносин</li>
                    </ul>

                    <h2>4. Моніторинг транзакцій</h2>
                    <p>4.1. Ми відстежуємо транзакції щодо:</p>
                    <ul>
                        <li>Підозрілих шаблонів</li>
                        <li>Великих транзакцій</li>
                        <li>Незвичайної активності</li>
                        <li>Індикаторів високого ризику</li>
                    </ul>

                    <h2>5. Звітність</h2>
                    <p>5.1. Ми повідомляємо про підозрілу діяльність відповідним органам.</p>
                    <p>5.2. Ми зберігаємо конфіденційність звітів та розслідувань.</p>

                    <h2>6. Навчання персоналу</h2>
                    <p>6.1. Наш персонал регулярно проходить навчання з AML.</p>
                    <p>6.2. Ми підтримуємо актуальні процедури відповідності.</p>`
    },
    privacy: {
        title: "Політика конфіденційності",
        content: `
            <h2>1. Вступ</h2>
            <p>1.1. Ця Політика конфіденційності пояснює, як Feennex збирає, використовує та захищає вашу особисту інформацію.</p>
            <p>1.2. Ми зобов'язуємося забезпечувати вашу конфіденційність та захищати ваші дані.</p>

            <h2>2. Інформація, яку ми збираємо</h2>
            <p>2.1. Ми збираємо такі типи інформації:</p>
            <ul>
                <li>Особиста ідентифікаційна інформація</li>
                <li>Контактна інформація</li>
                <li>Дані про транзакції</li>
                <li>Інформація про використання</li>
            </ul>

            <h2>3. Як ми використовуємо вашу інформацію</h2>
            <p>3.1. Ми використовуємо вашу інформацію для:</p>
            <ul>
                <li>Обробки ваших транзакцій</li>
                <li>Надання підтримки клієнтам</li>
                <li>Покращення наших послуг</li>
                <li>Дотримання законодавчих вимог</li>
            </ul>

            <h2>4. Безпека даних</h2>
            <p>4.1. Ми впроваджуємо надійні заходи безпеки для захисту ваших даних.</p>
            <p>4.2. Ми використовуємо шифрування та безпечні протоколи для передачі даних.</p>

            <h2>5. Ваші права</h2>
            <p>5.1. Ви маєте право:</p>
            <ul>
                <li>Отримати доступ до своїх персональних даних</li>
                <li>Запитати виправлення даних</li>
                <li>Запитати видалення даних</li>
                <li>Відкликати згоду</li>
            </ul>

            <h2>6. Зв'яжіться з нами</h2>
            <p>6.1. З питань конфіденційності звертайтеся за адресою support@feennex.com</p>
        `
    },
    agreement: {
        title: "Умови надання послуг",
        content: `
            <h2>1. Загальні положення</h2>
            <p>1.1. Ці Умови надання послуг регулюють відносини між Feennex ("Сервіс") та користувачами щодо використання платіжного сервісу.</p>
            <p>1.2. Використовуючи наш Сервіс, ви повністю погоджуєтесь з цими умовами.</p>

            <h2>2. Опис послуг</h2>
            <p>2.1. Feennex надає послуги з обробки платежів у криптовалюті та фіатній валюті.</p>
            <p>2.2. Сервіс включає, але не обмежується:</p>
            <ul>
                <li>Обробка криптовалютних платежів</li>
                <li>Операції з фіатною валютою</li>
                <li>Послуги конвертації валют</li>
                <li>Інструменти управління платежами</li>
            </ul>

            <h2>3. Обов'язки користувача</h2>
            <p>3.1. Користувачі повинні:</p>
            <ul>
                <li>Надавати точну інформацію</li>
                <li>Забезпечувати безпеку свого облікового запису</li>
                <li>Дотримуватися чинного законодавства</li>
                <li>Не використовувати сервіс для незаконної діяльності</li>
            </ul>

            <h2>4. Комісії за послуги</h2>
            <p>4.1. Структура комісій прозора та доступна в панелі користувача.</p>
            <p>4.2. Комісії можуть оновлюватися з попереднім повідомленням користувачів.</p>

            <h2>5. Відповідальність</h2>
            <p>5.1. Сервіс надається "як є" без гарантій.</p>
            <p>5.2. Користувачі несуть відповідальність за свої транзакції та безпеку облікового запису.</p>

            <h2>6. Зміни в умовах</h2>
            <p>6.1. Ми можемо оновлювати ці умови з повідомленням користувачів.</p>
            <p>6.2. Продовження використання після змін означає прийняття.</p>
        `
    },
};